import React from "react";
import { Modal } from "../../../../SharedComponents";
import { ModalNames } from "../../../../../Constants/modalNames";
import { useModal } from "../../../../../Store/modules/modal/modal";

export const PreviewSampleModal: React.FC = () => {
  const { modalProps } = useModal();
  const { link } = modalProps;
  return (
    <Modal
      modalName={ModalNames.PreviewSampleModal}
      modalClassName="lg:w-[700px] xs:h-auto xs:w-[90%] rounded-[5px] hide-scrollbar"
      ignorePadding
    >
      <img src={link} alt="sample-image" className="w-full h-full  rounded-[5px]" />
    </Modal>
  );
};
